/* Modo cinematográfico (2026-10-23) — ver sections/fs-cinema.liquid
 *  · topo: troca de jogos, profundidade com o rato, "afundar" com o scroll
 *  · cortina: o resto da página sobe por cima do topo (CSS em fs-cine.css)
 *  · cartões de produtos entram suavemente, uma vez
 * "Reduzir movimento" desliga as animações.
 */
(function () {
  'use strict';
  var reduz = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var raf = window.requestAnimationFrame.bind(window);
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };

  function medirHeader() {
    var h = document.querySelector('.header-wrapper');
    var r = h ? h.getBoundingClientRect() : null;
    document.documentElement.style.setProperty('--fs-header-h', (r ? Math.round(r.height) : 0) + 'px');
    // no topo da página o cabeçalho tem a barra da Black Friday por cima: o
    // topo cinematográfico ocupa só o resto do ecrã (medido uma vez, no topo)
    if (r && window.scrollY < 5) document.documentElement.style.setProperty('--fs-hero-off', Math.round(r.bottom) + 'px');
  }

  function cinema(sec) {
    var slides = [].slice.call(sec.querySelectorAll('.fsc__slide'));
    var tabs = [].slice.call(sec.querySelectorAll('.fsc__tab'));
    var intervalo = parseInt(sec.getAttribute('data-intervalo'), 10) || 7000;
    sec.style.setProperty('--t', intervalo + 'ms');
    var atual = 0, timer = null, visivel = true;
    var secWrap = sec.closest('.shopify-section') || sec;

    function ir(i) {
      atual = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-ativo', k === atual); s.setAttribute('aria-hidden', k === atual ? 'false' : 'true'); });
      tabs.forEach(function (t, k) {
        t.classList.remove('is-ativo');
        if (k === atual) { void t.offsetWidth; t.classList.add('is-ativo'); }
      });
      // carregar a imagem do seguinte antes de ser precisa
      var prox = slides[(atual + 1) % slides.length];
      if (prox) prox.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });
      agendar();
    }
    function agendar() {
      clearTimeout(timer);
      if (reduz || !visivel || slides.length < 2) return;
      timer = setTimeout(function () { ir(atual + 1); }, intervalo);
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { ir(parseInt(t.getAttribute('data-ir'), 10)); }); });

    // pausa quando o separador não está visível
    document.addEventListener('visibilitychange', function () { visivel = !document.hidden; sec.classList.toggle('is-pausa', !visivel); agendar(); });

    // deslizar no telemóvel
    var x0 = null;
    sec.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    sec.addEventListener('touchend', function (e) {
      if (x0 == null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 50) ir(atual + (dx < 0 ? 1 : -1));
    }, { passive: true });

    if (!reduz) {
      // profundidade com o rato (computador)
      var alvoX = 0, alvoY = 0, cx = 0, cy = 0, aMexer = false;
      sec.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var r = sec.getBoundingClientRect();
        alvoX = ((e.clientX - r.left) / r.width - .5) * -18;
        alvoY = ((e.clientY - r.top) / r.height - .5) * -12;
        if (!aMexer) { aMexer = true; raf(mexer); }
      });
      function mexer() {
        cx += (alvoX - cx) * .08; cy += (alvoY - cy) * .08;
        sec.style.setProperty('--mx', cx.toFixed(2) + 'px');
        sec.style.setProperty('--my', cy.toFixed(2) + 'px');
        if (Math.abs(alvoX - cx) > .05 || Math.abs(alvoY - cy) > .05) raf(mexer); else aMexer = false;
      }

      // afundar com o scroll (o resto da página sobe por cima)
      var pend = false;
      function scroll() {
        pend = false;
        var r = sec.getBoundingClientRect(), alt = sec.offsetHeight || 1;
        var hdr = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--fs-header-h')) || 0;
        var p = clamp((hdr - r.top) / alt, 0, 1);
        sec.style.setProperty('--p', p.toFixed(4));
        var fora = p >= 1;
        if (fora !== sec._fora) { sec._fora = fora; visivel = !fora && !document.hidden; agendar(); }
      }
      window.addEventListener('scroll', function () { if (!pend) { pend = true; raf(scroll); } }, { passive: true });
      scroll();
    }
    document.documentElement.classList.add('fs-cine-on');
    agendar();
  }

  // cartões de produtos: entrada suave, em cascata, uma vez
  function entradas() {
    if (reduz || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target, irmaos = el.parentElement ? [].slice.call(el.parentElement.children) : [];
        el.style.transitionDelay = Math.min(irmaos.indexOf(el) % 4, 3) * 70 + 'ms';
        el.classList.add('fs-in');
        io.unobserve(el);
      });
    }, { threshold: .15, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('#MainContent .product-grid-container > li, #MainContent .collection-list__item, #MainContent .grid__item').forEach(function (el) {
      if (el.closest('.fsc')) return;
      el.classList.add('fs-rev'); io.observe(el);
    });
  }

  function iniciar() {
    medirHeader();
    window.addEventListener('resize', medirHeader, { passive: true });
    document.querySelectorAll('[data-fsc]').forEach(cinema);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
